<mat-form-field class="bold-required-field__ui-kit tw-basis-1/2">
  <mat-label>{{ fieldLabel }}</mat-label>
  <mat-select
    [formControl]="fieldControl"
    [attr.test-id]="'dock'"
    [compareWith]="compareWithFn"
    [disabled]="disableField"
    (selectionChange)="onOptionSelected($event)"
  >
    <mat-option *ngFor="let dock of docks" [value]="dock" [attr.test-id]="testId">
      {{ dock.name }}
    </mat-option>
    <div *ngIf="isLoadMoreEnabled" class="load-more">
      <span class="link" (click)="onLoadMore()">
        <ui-svg-icon [name]="iconNames.Refresh" class="tw-align-middle"></ui-svg-icon>
        {{ 'monitoring.uli.create.uliInfo.loadMoreAddress' | translate : { amount: loadMoreAmount } }}
      </span>
    </div>
  </mat-select>
  <mat-error *ngIf="fieldControl.invalid && (fieldControl.dirty || fieldControl.touched)">
    <ui-field-error-messages [control]="fieldControl"></ui-field-error-messages>
  </mat-error>
</mat-form-field>
